import {Base} from "@/api/Base"

export class SalaryInformationAdd extends Base {
    path = "salaryInformation/add"
}